import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    root: {
      position: 'relative',
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      isolation: 'isolate',
    },
  },
  { name: 'appShell' }
);

export default useStyles;
